module.exports = __webpack_public_path__ + "static/media/ribboneel.67ee71af.png";